import React from 'react'
import Pagination from 'react-bootstrap/Pagination';

const AppPagination = ({ links, handlecCurrentPage, showingProducts, totalProducts }) => {

    return (
        <>

            <div className='row align-items-center mt-5'>

                <div className="col-lg-4">

                    <div>
                        <p className='mb-0'>Showing {showingProducts} Of {totalProducts}</p>
                    </div>

                </div>

                <div className="col-lg-8">

                    <Pagination className=''>
                        {
                            Array.isArray(links) && (
                                links?.map((item) => {
                                    if (item?.label == "&laquo; Previous") {
                                        return <Pagination.Prev
                                            onClick={() => {
                                                if (item?.url) {
                                                    handlecCurrentPage(item?.url.split("page=")[1])
                                                }
                                            }}
                                        />
                                    } else if (item?.label == "Next &raquo;") {
                                        return <Pagination.Next
                                            onClick={() => {
                                                if (item?.url) {
                                                    handlecCurrentPage(item?.url.split("page=")[1])
                                                }
                                            }}
                                        />
                                    } else {
                                        return <Pagination.Item active={item?.active}
                                            onClick={() => {
                                                if (item?.url) {
                                                    handlecCurrentPage(item?.url.split("page=")[1])
                                                }
                                            }}
                                        >{item?.label}</Pagination.Item>
                                    }
                                })
                            )
                        }
                        {/* <Pagination.Ellipsis /> */}
                    </Pagination>

                </div>
            </div>
        </>

    )
}

export default AppPagination